import React, { useEffect, useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, RequiredRule, StringLengthRule, EmptyItem, AsyncRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux'
import { billDialogAction } from '../../store/bill/billDialogReducer';
import { createStore, createStoreLocal } from '../../utils/proxy';
import { editorOptionsSelect, editorOptionsSelectClear, formatDate } from '../../data/app';
import { DataGrid, Button } from 'devextreme-react';
import { Column, Editing, Lookup, RequiredRule as RuleRequired, Button as ButtonGrid, Summary, TotalItem } from 'devextreme-react/data-grid';
import ItemDDBComponent from '../../components/dropdown/ItemDDBComponent';
import toCapital, { cellRender, obtenerTasaCambio, padIdInfo, valueHasAny, valueIsNullOrEmpty } from '../../utils/common';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import useItems from '../../hooks/useItems';
import { billDefault, paymentType, typesBill } from '../../data/bill';
import { editorOptionsDropDown } from '../../components/dropdown/ClienteDropDown';
import uri from '../../utils/uri';
import Resumen from '../../components/grids/Resumen';
import Discounts from '../../components/grids/Discounts';
import { paymentMethod } from '../../data/enums';

const Nuevo = props => {

    const { config } = props;

    const { billDialog, appInfo } = useSelector(store => store);

    const billDefaultCustom = { ...billDefault, clientId: billDialog.clientId, paymentTypeId: config.typeId == typesBill.cotizacion ? paymentType.contado : null };

    const isBill = config.typeId == typesBill.factura;
    const isQuote = !isBill;

    const { items, setItems } = useItems({ open: billDialog.open});
    const [ bill, setBill] = useState({ ...billDefaultCustom });
    const [ saving, setSaving ] = useState(false);
    const [ resumenData, setResumenData ] = useState([]);

    let refForm = useRef();
    let refGrid = useRef();

    useEffect(() => {

        if (billDialog.open) {

            http(uri.items.asCatalog).asGet().then(resp => {

                http('bill/get/maxId').asGet().then(c => {

                    setItems(resp);

                    setBill({ ...billDefaultCustom, idMax: c.idMax, clientId: billDialog.clientId, billDetails: [] });

                    obtenerTasaCambio(new Date()).then(rate => {

                        if (billDialog.id > 0) {
                            http(config.uri.getById(billDialog.id)).asGet().then(resp => {

                                const { billDetails, ...rest } = resp;

                                setBill({ ...billDefaultCustom, ...rest , idMax: rest.id , billDetails: [...billDetails] });

                                setResumenData([...billDetails]);

                            });
                        } else {
                            if (rate)
                                setBill({ ...billDefaultCustom, billDetails : [], rate: rate.value, clientId: billDialog.clientId, idMax: c.idMax });
                            setResumenData([]);
                        }

                    });

                });

            });
        }

    }, [billDialog.open]);

    const dispatch = useDispatch();

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar articulo',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => refGrid.current.instance.addRow()
            }
        });
    }

    const closeDialog = (load, id) => {

        refForm.current.instance.resetValues();
        refGrid.current.instance.cancelEditData();

        dispatch(billDialogAction({ id: 0, clientId: null, open: false }));
        if (load) {
            let { onSave } = props;
            onSave({id});
        }
    }

    const onHiding = ({ load }) => {
        closeDialog(load);
    }

    const guardarFactura = async (e) => {


        let resultValidate = refForm.current.instance.validate();

        let result = resultValidate;

        if(resultValidate.complete)
            result = await resultValidate.complete; 
       
        if (result.isValid) {

            setSaving(true);
            let data = { ...bill };

            http(config.uri.insert).asPost(data).then(resp => {
                setSaving(false);
                notify(`${toCapital(config.text)} registrada correctamente`);
                closeDialog(true, resp.id);
            }).catch(err => {
                setSaving(false);
                notify(err, 'error', 5000);
            });

        }
           

    }

    const setCellValue = async (prop, newData, value, currentRowData) => {

        let percent = 0;
        if (bill.discountValue == "PVT1")
            percent = appInfo.pvt1;
        if (bill.discountValue == "PVT2")
            percent = appInfo.pvt2;
        if (bill.discountValue == "PVT3")
            percent = appInfo.pvt3;

        newData[prop] = value || 0;
        if (prop == 'itemId' && value) {

            let info = items.find(x => x.id == value);

            let valor = bill.discountValue == "PVT4" ? info.cost : info.price;
            let original = info.price;
            let originalCost = info.cost;

            if(info.typeId == 6){

                if(bill.clientId > 0){
                    const existaData = await http('scleralsclient/get/' + bill.clientId).asGet();
                    if (existaData?.length > 0) {
                        original= existaData[0].price;
                        valor = original;

                        originalCost = existaData[0].cost;
                    }
                }

            }

            newData['price'] = valor;
            newData['cost'] = info.cost;

            !currentRowData['quantity'] && (newData['quantity'] = 1);

            newData['import'] = valor;

            const discount = (valor * percent);

            newData['discount'] = discount;
            newData['subTotal'] = valor - discount;
            newData['iva'] = 0;
            newData['original'] = original;
            newData['originalCost'] = originalCost;

            !currentRowData['total'] && (newData['total'] = newData['subTotal']);

        }

        if (prop == 'quantity' && (+value) >= 0) {

            let valor = bill.discountValue == "PVT4" ? currentRowData['cost'] : currentRowData['price'];

            newData['price'] = valor;
            newData['import'] = valor * value;
            newData['discount'] = (valor * percent * value);
            newData['subTotal'] = newData['import'] - newData['discount'];
            newData['iva'] = 0;
            newData['total'] = newData['subTotal'];


        }

    }

    const onCellPrepared = e => {

        const cellsQuantity = ['quantity', 'quantityRequest']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                e.cellElement.classList.add('quantity-text');
        }

    }


    const isTranferOrCheckOrCard = value => [paymentMethod.cheque, paymentMethod.tarjeta, paymentMethod.deposito].includes(value);


    const validatePaymentMethod = e => {

        const result =  (bill.paymentTypeId == paymentType.contado && valueHasAny(e.value)) || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(e.value))
        
       
        return new Promise(resolve => {
            resolve(
                result
            );
        });
    }

    const validateReference = e => {

        const result = isQuote || (isBill && !valueIsNullOrEmpty(e.value));

        return new Promise(resolve => {
            resolve(
                result
            );
        });

    }

    const validateBank = e => {
        console.log(bill);
        console.log(e);
        return new Promise(resolve => {
            resolve(
                (bill.paymentTypeId == paymentType.contado && bill.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(e.value))
                || (bill.paymentTypeId == paymentType.contado && isTranferOrCheckOrCard(bill.paymentMethodId) && valueHasAny(e.value))
                || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(e.value))

            );
        });
    }

    const validateReferencePayment = e => {
        return new Promise(resolve => {
            resolve(
                (bill.paymentTypeId == paymentType.contado && bill.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(e.value))
                || (bill.paymentTypeId == paymentType.contado && isTranferOrCheckOrCard(bill.paymentMethodId) && valueHasAny(e.value))
                || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.paymentMethodId))
            );
        });
    }

    // const validateReference = e => {
    //     return new Promise(resolve => {
    //         resolve(
    //             (bill.paymentTypeId == paymentType.contado && valueHasAny(bill.reference))
    //             || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.reference))
    //         );
    //     });
    // }

    const onRowInserted = e => {
        setResumenData([...bill.billDetails])
    }

    const onRowRemoved = e => {
        setResumenData([...bill.billDetails])
    }

    const applyDiscount = async(e) => {

        await refGrid.current.instance.saveEditData();
       

        const { value } = e;

        let percent = 0;

        if (value == "PVT1")
            percent = appInfo.pvt1;
        if (value == "PVT2")
            percent = appInfo.pvt2;
        if (value == "PVT3")
            percent = appInfo.pvt3;

        const newData = bill.billDetails.map((x) => {

            let info = items.find(i => i.id == x.itemId);

            let valor = value == "PVT4" ? info.cost : info.price;

            if(info.typeId == 6){

                if(bill.clientId > 0){
                    valor = value == "PVT4" ? x.originalCost : x.original;
                }

            }

            x.price = valor
            x.import = valor * x.quantity;
            x.discount = valor * x.quantity * percent;
            x.subTotal = x.import - x.discount;
            x.total = x.subTotal;

            return x;

        });
            
        setBill({ ...bill, discountValue: value, billDetails: [...newData] });
        setResumenData([...bill.billDetails]);
        

    }

    useEffect(() => {
        if (billDialog.open)
            obtenerTasaCambio(new Date()).then(rate => {
                if (rate)
                    setBill({ ...bill, rate: rate.value });
            });
    }, [billDialog.open]);


    const disabled = billDialog.id > 0;
    const padId = padIdInfo(appInfo);

    return (
        <div>
            <Popup
                width={1050}
                height={700}
                title={billDialog.id > 0 ? `Ver ${config.text} No ${padId(bill.idMax)}` : `Nueva ${config.text} No ${padId(bill.idMax)}`}
                onHiding={onHiding}
                visible={billDialog.open}
                className="bg-fbfbfb"
            >
                <Form formData={bill} ref={refForm}>
                    <GroupItem colCount={3}>
                        <SimpleItem dataField="date" editorType="dxDateBox"
                            editorOptions={{
                                displayFormat: formatDate,
                                openOnFieldClick: true,
                            }} >
                            <Label text="Fecha" />
                            <RequiredRule message="Seleccione la fecha" />
                        </SimpleItem>
                        <SimpleItem dataField="paymentTypeId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'billPaymentType' }),
                                ...editorOptionsSelect,
                                disabled: config.typeId == typesBill.cotizacion,
                                onValueChanged: e =>  {

                                    const creditDays =  e.value == paymentType.contado ? 0 : appInfo.creditLimit;
                                    const isContado = e.value == paymentType.contado;


                                    setBill({ ...bill, 
                                        paymentTypeId: e.value, 
                                        creditDays: creditDays,
                                        paymentMethodId : null,
                                        bankId : isContado ? null : bill.bankId,
                                        referencePayment : isContado ? '' : bill.referencePayment,
                                    })
                                } 
                            }} >
                            <Label text="Tipo pago" />
                            <RequiredRule message="Seleccione el tipo" />
                        </SimpleItem>
                        <SimpleItem dataField="creditDays" editorType="dxNumberBox"
                            editorOptions={{
                                disabled: true
                            }} >
                            <Label text="Dias crédito" />
                            <RequiredRule message="Seleccione el tipo" />
                        </SimpleItem>
                        <SimpleItem dataField="clientId" colSpan={3} editorType="dxSelectBox"
                            editorOptions={editorOptionsDropDown} >
                            <Label text="Cliente" />
                            <RequiredRule message="Seleccione el cliente" />
                        </SimpleItem>

                        
                        {/* <SimpleItem dataField="reference" >
                            <Label text="No Factura" />
                            <AsyncRule message="Numero de factura" validationCallback={validateReference}></AsyncRule>
                        </SimpleItem> */}
                        <SimpleItem dataField="paymentMethodId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'billPaymentMethod' }),
                                ...editorOptionsSelect,
                                disabled: (config.typeId == typesBill.cotizacion || bill.paymentTypeId != paymentType.contado),
                                onValueChanged: e =>  {

                                    const isEfectivo = e.value == paymentMethod.efectivo;

                                    setBill({ ...bill, 
                                        paymentMethodId: e.value,
                                        bankId : isEfectivo ? null : bill.bankId,
                                        referencePayment : isEfectivo ? '': bill.referencePayment
                                    })
                                } 
                            }} >
                            <Label text="Forma pago" />
                            <AsyncRule message="Seleccione la forma de pago" validationCallback={validatePaymentMethod}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="bankId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'Bank' }),
                                ...editorOptionsSelect,
                                disabled: (config.typeId == typesBill.cotizacion || bill.paymentMethodId == paymentType.contado || bill.paymentTypeId == paymentType.credito),
                            }} >
                            <Label text="Banco" />
                            <AsyncRule message="Seleccione el banco" validationCallback={validateBank}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="referencePayment"
                            editorOptions={{
                                disabled:  config.typeId == typesBill.cotizacion || bill.paymentMethodId == paymentType.contado || bill.paymentTypeId == paymentType.credito,
                            }} >
                            <Label text="Referencia" />
                            <AsyncRule message="Ingrese la referencia" validationCallback={validateReferencePayment}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="observation" colSpan={3} >
                            <Label text="Observacion" />
                            <StringLengthRule max={150} message="Maximo 150 caracteres" />
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                        <DataGrid id="gridDetails"
                            ref={refGrid}
                            selection={{ mode: 'single' }}
                            dataSource={bill.billDetails}
                            showBorders={true}
                            showRowLines={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            height={280}
                            onToolbarPreparing={onToolbarPreparing}
                            onCellPrepared={onCellPrepared}
                            onRowInserted={onRowInserted}
                            onRowUpdated={onRowInserted}
                            onRowRemoved={onRowRemoved}
                        >
                            <Column dataField="itemId" caption="Producto"
                                setCellValue={setCellValue.bind(null, "itemId")}
                                editCellComponent={ItemDDBComponent}
                            >
                                <Lookup
                                    dataSource={items}
                                    valueExpr="id"
                                    displayExpr={item => item ? `${item.code} - ${item.name}` : ''}

                                />
                                <RuleRequired />
                            </Column>
                            <Column dataField="quantity" caption="Cantidad" dataType="number" width={80}
                                setCellValue={setCellValue.bind(null, "quantity")}
                            >
                                <RuleRequired />
                            </Column>
                            <Column dataField="price" caption="Precio Vta" dataType="number" width={100} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column dataField="total" caption="Total" dataType="number" width={150} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column type="buttons" width={50}>
                                <ButtonGrid name="delete" />
                            </Column>

                            <Editing
                                mode="cell"
                                allowDeleting={true}
                                allowUpdating={true}
                                selectTextOnEditStart={true}
                                useIcons={true}
                            ></Editing>
                            {/* <Summary>
                                <TotalItem
                                    column="total"
                                    summaryType="sum"
                                    customizeText={data => `Total: ${formatToMoney(data.value)}`}
                                />
                            </Summary> */}
                        </DataGrid>
                        <div className='div-col-2'>
                            <Discounts value={bill.discountValue} callback={applyDiscount} />
                            <Resumen data={resumenData} bill={bill} />
                        </div>
                    </GroupItem>
                </Form>

                <Button
                    className="mt-10"
                    text={saving ? 'Guardando...' : `Guardar ${config.text}`}
                    type="success"
                    icon='save'
                    disabled={saving || disabled}
                    onClick={guardarFactura}
                />
            </Popup>
        </div>
    );
}

export default Nuevo;
